import { useEffect, useMemo, useState } from 'react';

export interface IWindowDimensionsResult {
  width: number;
  height: number;
}
const getWindowDimensions = (): IWindowDimensionsResult => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const useWindowDimensions = (): IWindowDimensionsResult => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions);

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return useMemo(() => windowDimensions, [windowDimensions]);
};
